module.exports = __webpack_public_path__ + "img/logo-sky-blue.81c8ac92.png";